<template>
    <section class="package-exclusions">
        <h2>Исключения из комплекта на начисление ЗП</h2>
        <p>Все табели выбранного объекта исключаются из комплекта и не мешают его передаче, даже если есть сменные отчёты
            или объект отмечен как обязательный. В готовности комплекта останется отметка «Исключён настройками».</p>
        <p class="text-muted">Месяцы включаются целиком. Постоянное исключение действует с выбранного месяца без окончания.
            Чтобы возобновить включение объекта, задайте последний месяц исключения. Уже переданные комплекты сохраняют свой состав;
            изменения применятся при следующей передаче, в том числе исправленного комплекта.</p>
        <p v-if="!value.length" class="text-muted">Исключений нет.</p>
        <article v-for="(row, index) in value" :key="index" class="package-exclusions__row">
            <div class="package-exclusions__object">
                <label :for="`package-object-${index}`">Объект</label>
                <v-select :value="row.building_id" :options="objectOptions" label="text" :reduce="object => object.value"
                    :input-id="`package-object-${index}`" placeholder="Найти объект"
                    @input="change(index, 'building_id', $event)" />
            </div>
            <label>Срок
                <b-form-select :value="row.through_month === null ? 'permanent' : 'temporary'"
                    :options="durationOptions" @change="setDuration(index, $event)" />
            </label>
            <label>С месяца
                <input type="month" class="form-control" :value="row.from_month" required
                    @input="change(index, 'from_month', $event.target.value)">
            </label>
            <label v-if="row.through_month !== null">По месяц включительно
                <input type="month" class="form-control" :value="row.through_month" :min="row.from_month" required
                    @input="change(index, 'through_month', $event.target.value)">
            </label>
            <span v-else class="text-muted">Без окончания</span>
            <b-button variant="outline-danger" size="sm" :aria-label="`Удалить исключение ${objectName(row.building_id)}`"
                @click="$emit('input', value.filter((_, i) => i !== index))">Удалить</b-button>
            <label class="package-exclusions__reason">Причина (необязательно)
                <AppTextarea :value="row.reason" maxlength="1000" placeholder="Будет видна в готовности комплекта"
                    @input="change(index, 'reason', $event)" />
            </label>
        </article>
        <b-button variant="outline-primary" size="sm" @click="add">Добавить исключение</b-button>
        <p class="text-muted mt-3 mb-0">Изменения вступят в силу после нажатия «Сохранить».</p>
    </section>
</template>
<script>
import moment from 'moment';

export default {
    name: 'TimesheetPackageExclusions',
    props: {value: {type: Array, default: () => []}, objects: {type: Array, default: () => []}},
    data: () => ({durationOptions: [{value: 'temporary', text: 'Временное'}, {value: 'permanent', text: 'Постоянное'}]}),
    computed: {
        objectOptions() {
            const options = this.objects.map(object => ({value: Number(object.building_id),
                text: object.name + (object.is_active ? '' : ' (архив)')}));
            this.value.forEach(row => {
                if (row.building_id && !options.some(option => option.value === Number(row.building_id))) {
                    options.push({value: Number(row.building_id), text: `Объект #${row.building_id}`});
                }
            });
            return options;
        }
    },
    methods: {
        objectName(id) { const row = this.objectOptions.find(option => option.value === Number(id)); return row ? row.text : ''; },
        change(index, key, value) {
            this.$emit('input', this.value.map((row, i) => i === index ? {...row, [key]: value} : row));
        },
        setDuration(index, value) {
            this.change(index, 'through_month', value === 'permanent' ? null : this.value[index].from_month);
        },
        add() {
            const month = moment().utcOffset(180).subtract(1, 'month').format('YYYY-MM');
            this.$emit('input', this.value.concat({building_id: null, from_month: month, through_month: month, reason: ''}));
        }
    }
};
</script>
<style scoped>
.package-exclusions { padding: .75rem; }
.package-exclusions h2 { font-size: 1.2rem; }
.package-exclusions__row { display: grid; grid-template-columns: minmax(220px, 2fr) minmax(135px, 1fr) minmax(150px, 1fr) minmax(165px, 1fr) auto; gap: .75rem; align-items: end; padding: .85rem; margin-bottom: .75rem; border: 1px solid #d9e2ec; border-radius: 8px; }
.package-exclusions__row label { display: block; margin: 0; }
.package-exclusions__reason { grid-column: 1 / -1; }
@media (max-width: 1000px) { .package-exclusions__row { grid-template-columns: 1fr 1fr; } .package-exclusions__object { grid-column: 1 / -1; } }
@media (max-width: 540px) { .package-exclusions__row { grid-template-columns: minmax(0, 1fr); } }
</style>
